import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface ServiceDetailFeaturesProps {
  data: {
    title: string;
    features: Array<{
      icon: string;
      title: string;
      description: string;
    }>;
  };
}

const ServiceDetailFeatures = ({ data }: ServiceDetailFeaturesProps) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-16 bg-gradient-to-br from-[#007dff]/5 via-white to-[#007dff]/5">
      <div className="max-w-[1440px] mx-auto px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="font-poppins font-bold text-2xl lg:text-3xl text-gray-900 mb-3">
            {data.title}
          </h2>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-5 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#007dff]/10 rounded-xl mb-4 group-hover:bg-[#007dff] transition-all duration-300">
                <i className={`${feature.icon} text-2xl text-[#007dff] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-poppins font-semibold text-base text-gray-900 mb-2 group-hover:text-[#007dff] transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="font-poppins text-[13px] text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailFeatures;
